import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { api, gbp, imgSrc, formatApiError } from "@/lib/api";
import { StatusBadge } from "@/components/site/StatusBadge";
import { ListingDialog } from "@/components/admin/ListingDialog";

export const AdminListings = ({ kind, onChange }) => {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [open, setOpen] = useState(false);
  const isProps = kind === "properties";

  const load = useCallback(() => {
    api.get(isProps ? "/admin/properties" : "/deals").then((r) => setItems(r.data)).catch((e) => toast.error(formatApiError(e)));
  }, [isProps]);
  useEffect(load, [load]);

  const saved = () => { load(); onChange?.(); };
  const remove = async (it) => {
    if (!window.confirm(`Delete "${it.title}"?`)) return;
    try {
      await api.delete(`${isProps ? "/admin/properties" : "/admin/deals"}/${it.id}`);
      toast.success("Deleted");
      saved();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div>
      <div className="flex justify-between items-center">
        <p className="text-sm text-[#57534E]">{items.length} {isProps ? "properties" : "completed deals"}</p>
        <button onClick={() => { setEditing(null); setOpen(true); }} data-testid={isProps ? "admin-btn-add-property" : "admin-btn-add-deal"}
          className="h-10 px-5 inline-flex items-center gap-2 bg-[#9F7E44] text-white text-sm hover:bg-[#866835]">
          <Plus className="h-4 w-4" /> {isProps ? "Add property" : "Add completed deal"}
        </button>
      </div>
      <div className="mt-5 grid gap-3">
        {items.map((it) => (
          <div key={it.id} data-testid={`admin-listing-${it.id}`} className="bg-white border border-[#E4E1D9] p-4 flex items-center gap-4">
            <div className="h-16 w-20 shrink-0 bg-[#F3F1ED] overflow-hidden">
              {it.images?.[0] && <img src={imgSrc(it.images[0])} alt="" className="h-full w-full object-cover" />}
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-medium truncate">{it.title}</p>
              <p className="font-plex text-xs text-[#847F77] truncate">
                {it.area} · {isProps ? `${gbp(it.price)} · ${it.bedrooms} bed` : it.sale_price != null ? gbp(it.sale_price) : "Price not shown"}
                {it.is_sample && " · SAMPLE"}
              </p>
            </div>
            {isProps && <span className="hidden sm:block"><StatusBadge status={it.status} /></span>}
            <button onClick={() => { setEditing(it); setOpen(true); }} data-testid={`admin-edit-${it.id}`} className="p-2 hover:text-[#9F7E44]" aria-label="Edit"><Pencil className="h-4 w-4" /></button>
            <button onClick={() => remove(it)} data-testid={`admin-delete-${it.id}`} className="p-2 hover:text-red-700" aria-label="Delete"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
      <ListingDialog kind={kind} item={editing} open={open} onOpenChange={setOpen} onSaved={saved} />
    </div>
  );
};
